import { Action } from '@ngrx/store';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { IActionOptions } from '@interfaces/IActionOptions';
import { ICompany, IGraduates, IVacancies } from '@interfaces/ICompany';

export enum ECompaniesViewActions {
  GetCompaniesRequest = '[Companies view] Get Companies Request',
  GetCompaniesSuccess = '[Companies view] Get Companies Success',
  GetCompaniesFailure = '[Companies view] Get Companies Failure',
  ClearCompanies = '[Companies view] Clear Companies',

  GetGraduatesRequest = '[Companies view] Get Graduates Request',
  GetGraduatesSuccess = '[Companies view] Get Graduates Success',
  GetGraduatesFailure = '[Companies view] Get Graduates Failure',
  ClearGraduates = '[Companies view] Clear Graduates',

  GetVacanciesRequest = '[Companies view] Get Vacancies Request',
  GetVacanciesSuccess = '[Companies view] Get Vacancies Success',
  GetVacanciesFailure = '[Companies view] Get Vacancies Failure',
  ClearVacancies = '[Companies view] Clear Vacancies',
}

export class GetCompaniesRequest implements Action {
  public readonly type = ECompaniesViewActions.GetCompaniesRequest;
  constructor(public options?: IActionOptions) {}
}

export class GetCompaniesSuccess implements Action {
  public readonly type = ECompaniesViewActions.GetCompaniesSuccess;

  constructor(public companies: ICompany) {}
}

export class GetCompaniesFailure implements Action {
  public readonly type = ECompaniesViewActions.GetCompaniesFailure;
  constructor(public error: IFormErrors) {}
}

export class ClearCompanies implements Action {
  public readonly type = ECompaniesViewActions.ClearCompanies;
}

export class GetGraduatesRequest implements Action {
  public readonly type = ECompaniesViewActions.GetGraduatesRequest;
  constructor(public options?: IActionOptions) {}
}

export class GetGraduatesSuccess implements Action {
  public readonly type = ECompaniesViewActions.GetGraduatesSuccess;

  constructor(public graduates: IGraduates) {}
}

export class GetGraduatesFailure implements Action {
  public readonly type = ECompaniesViewActions.GetGraduatesFailure;
  constructor(public error: IFormErrors) {}
}

export class ClearGraduates implements Action {
  public readonly type = ECompaniesViewActions.ClearGraduates;
}

export class GetVacanciesRequest implements Action {
  public readonly type = ECompaniesViewActions.GetVacanciesRequest;
  constructor(public options?: IActionOptions) {}
}

export class GetVacanciesSuccess implements Action {
  public readonly type = ECompaniesViewActions.GetVacanciesSuccess;

  constructor(public vacancies: IVacancies) {}
}

export class GetVacanciesFailure implements Action {
  public readonly type = ECompaniesViewActions.GetVacanciesFailure;
  constructor(public error: IFormErrors) {}
}

export class ClearVacancies implements Action {
  public readonly type = ECompaniesViewActions.ClearVacancies;
}

export type CompaniesViewActions =
  | GetCompaniesRequest
  | GetCompaniesSuccess
  | GetCompaniesFailure
  | ClearCompanies
  | GetGraduatesRequest
  | GetGraduatesSuccess
  | GetGraduatesFailure
  | ClearGraduates
  | GetVacanciesRequest
  | GetVacanciesSuccess
  | GetVacanciesFailure
  | ClearVacancies;
